import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';

import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Col,
} from "reactstrap";
import classnames from "classnames";

import CompanyForm from "./Form"

import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function TabsForm() {
    const { id } = useParams();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState('form');

    const pathFrontEnd = '/businessmanagers/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}businessmanagers/delete`,
        endpoint: config.endpoints.backend + 'businessmanagers/getByCompany'
    }

    let list = {
        labelTitle: 'Lista de Gestor de Empresa',
        labelTitleButtonAdd: 'Incluir novo gestor de empresa',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        viewActionColumn: false,
        buttonsListContainer: [
            {
                name: 'send',
                class: 'btn btn-primary',
                label: 'Novo',
                tooltipLabel: 'Novo Gestor de Empresa',
                callback: async () => {
                    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_company_id_to_add', value: id });
                    navigate(`${pathFrontEnd}add`)
                }
            }
        ],
        filter: {
            pdc_company_id: id
        },
        columns: [
            {
                name: 'name',
                label: 'Nome do Gestor'
            },
            {
                name: 'status',
                label: 'Status'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "form" })}
                        onClick={() => {
                            setActiveTab("form");
                        }}
                    >
                        Empresa
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "businessmanagers" })}
                        onClick={() => {
                            setActiveTab("businessmanagers");
                        }}
                    >
                        Gestores de Empresa
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="form">
                    <Col sm="12">
                        <CompanyForm />
                    </Col>
                </TabPane>
                <TabPane tabId="businessmanagers">
                    <Col sm="12">
                        <CustomListContainer
                            buttons={list.buttonsListContainer}
                            canAdd={list.canAdd}
                            pathAdd={list.pathAdd}
                            labelTitle={list.labelTitle}
                            labelTitleButtonAdd={list.labelTitleButtonAdd}
                            content={<CustomList list={{ ...list, ...paths }} />}
                        />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
}
export default TabsForm;
